import styled from "styled-components";

export const Container = styled.div``;

export const NonProfitsContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(20)};
`;
